var map = {
	"./_baseform/baseform.module": [
		"../../../../../src/app/main/_baseform/baseform.module.ts",
		"common",
		"baseform.module"
	],
	"./home/home.module": [
		"../../../../../src/app/main/home/home.module.ts",
		"home.module"
	],
	"./login/login.module": [
		"../../../../../src/app/login/login.module.ts",
		"common",
		"login.module"
	],
	"./main/main.module": [
		"../../../../../src/app/main/main.module.ts",
		"common",
		"main.module"
	],
	"./permission/permission.module": [
		"../../../../../src/app/main/permission/permission.module.ts",
		"common",
		"permission.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/01.Developer/0.Web/Bravo8-Base/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main